import { defineComponent, ref } from 'vue-demi';
import { Picker } from '@onereach/emoji-picker-element';
import { openBlock, createElementBlock } from 'vue';

function toDashes(key) {
  return key.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`);
}

var script = defineComponent({
  props: {
    skinToneEmoji: {
      type: String,
      default: null
    },
    customEmoji: {
      type: Array,
      default: () => null
    },
    locale: {
      type: String,
      default: null
    },
    customCategorySorting: {
      type: Function,
      default: () => null
    },
    i18n: {
      type: Object,
      default: () => null
    },
    pickerStyle: {
      type: Object,
      default: () => null
    }
  },
  emits: ['emojiClick', 'skinToneChange'],
  setup() {
    const container = ref();
    //for now work only with light theme
    const isDark = false;
    return {
      isDark,
      container
    };
  },
  data: () => ({
    picker: new Picker()
  }),
  mounted() {
    var _a;
    this.updatePickerProps();
    (_a = this.container) === null || _a === void 0 ? void 0 : _a.appendChild(this.picker);
    this.picker.addEventListener('emoji-click', this.handleClick);
    this.picker.addEventListener('skin-tone-change', this.handleSkinToneChange);
  },
  beforeUnmount() {
    this.picker.removeEventListener('emoji-click', this.handleClick);
    this.picker.removeEventListener('skin-tone-change', this.handleSkinToneChange);
  },
  methods: {
    handleClick(event) {
      this.$emit('emojiClick', event.detail);
    },
    handleSkinToneChange(event) {
      this.$emit('skinToneChange', event.detail);
    },
    updatePickerProps() {
      const {
        skinToneEmoji,
        locale,
        customEmoji,
        i18n,
        customCategorySorting
      } = this.$props;
      if (skinToneEmoji) this.picker.skinToneEmoji = skinToneEmoji;
      if (locale) this.picker.locale = locale;
      if (customEmoji) this.picker.customEmoji = customEmoji;
      if (i18n) this.picker.i18n = i18n;
      if (customCategorySorting) this.picker.customCategorySorting = customCategorySorting;
      this.picker.classList.toggle('dark', this.isDark);
      this.picker.classList.toggle('light', !this.isDark);
      this.updatePickerStyle();
    },
    updatePickerStyle() {
      if (this.pickerStyle && typeof this.pickerStyle === 'object') {
        Object.keys(this.pickerStyle).forEach(key => {
          var _a, _b;
          if (key === 'height' && ((_a = this.pickerStyle) === null || _a === void 0 ? void 0 : _a.height)) this.picker.style.setProperty('height', this.pickerStyle.height);else if (key === 'width' && ((_b = this.pickerStyle) === null || _b === void 0 ? void 0 : _b.width)) this.picker.style.setProperty('width', this.pickerStyle.width);else this.picker.style.setProperty(`--${toDashes(key)}`, this.pickerStyle[key] || null);
        });
      }
    }
  }
});

const _hoisted_1 = {
  ref: "container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, null, 512 /* NEED_PATCH */);
}

script.render = render;
script.__file = "src/components/EmojiPicker/EmojiPicker.vue";

export { script as s };
